export { default as HowToGetCinchCharge } from './how-to-get-cinchcharge/how-to-get-cinchcharge'
